import { Channel } from "../common/transmit";
import { CustomEventTypeEnum } from "../common/enums";

function getTargetByNode(node) {
  const { data = {} } = node
  const label = node.data.tooltip
  const { actionType, jobType, jobCode } = data
  return { node, label, nodeId: node.id, actionType, jobType, jobCode }
}

export default (graph) => {
  const tooltipDom = document.getElementById("tooltip-container")
  graph.on('cell:removed', ({ cell }) => {
    tooltipDom.style.display = 'none'
    if (cell.isNode()) {
      const detail = getTargetByNode(cell)
      Channel.dispatchEvent(CustomEventTypeEnum.NODE_REMOVE, detail)
    }
  });
}
